// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"154e6dfc","308":"418831e6","353":"ba4d3e6f","398":"7b70be49","407":"ea997fb6","758":"d948bd79","956":"4938e717"}[chunkId] + ".chunk.js";
};